<template>
  <div>
    <create
      @closePopup="createDialog = false"
      @createData="create($event)"
      @getShcools="getSchoolIems($event)"
      :schoolItems="schoolItems"
      :dialog="createDialog"
      :loader="createLoader"
    />
    <edit
      @closePopup="editDialog = false"
      @editData="edit($event)"
      @getShcools="getSchoolIems($event)"
      :schoolItems="schoolItems"
      :dialog="editDialog"
      :dialogData="dialogData"
      :loader="showLoader"
    />
    <delete-popup
      @closePopup="deleteDialog = false"
      @deleteData="deleteItem($event)"
      :dialog="deleteDialog"
      :item="deleteDialogData"
      :loader="deleteLoader"
    />
    <v-row class="mb-4">
      <v-col class="d-flex justify-end"
        ><v-btn color="primary" @click="createAble"
          ><span style="color: white;">{{ $t("add") }}</span></v-btn
        ></v-col
      >
    </v-row>
    <data-table
      @updatePage="getData($event)"
      :headers="tableData.headers"
      :data="tableData.data"
      :editable="editAble"
      :deleteable="deleteAble"
      :loader="loader"
      :meta="pagination"
    />
  </div>
</template>
<script>
import { Semester } from "@/store/common/semester";
import { School } from "@/store/common/school";
import dataTable from "@/components/mycomponent/base/dataTable.vue";
import create from "./create.vue";
import edit from "./edit.vue";
import deletePopup from "@/pages/Dashboard/age-group/delete.vue";
export default {
  components: {
    dataTable,
    create,
    edit,
    deletePopup,
  },
  data() {
    return {
      Semester,
      School,
      createDialog: false,
      editDialog: false,
      dialogData: null,
      deleteDialog: false,
      deleteDialogData: null,
      schoolItems: [],
    };
  },
  methods: {
    getData(page) {
      let params = {
        page: page,
      };
      Semester.get(params);
      this.dialog = false;
    },
    async getSchoolIems(params) {
      await School.get(params);
      this.schoolItems = this.schoolItems.concat(this.shcoolData);
    },

    //create
    createAble() {
      this.createDialog = true;
    },
    async create(data) {
      await Semester.post(data);
      this.createDialog = false;
    },

    //edit
    async editAble(obj) {
      this.editDialog = true;
      await Semester.show(obj.id);
      this.dialogData = Semester.tableData.showData;
    },
    async edit(data) {
      await Semester.edit(data.data, data.id);
      this.editDialog = false;
    },

    //delete
    deleteAble(obj) {
      this.deleteDialog = true;
      this.deleteDialogData = obj;
    },
    async deleteItem(id) {
      await Semester.deleteItem(id);
      this.deleteDialog = false;
    },
  },
  computed: {
    //data
    tableData() {
      return Semester.tableData;
    },
    shcoolData() {
      return School.tableData.data;
    },
    pagination() {
      return Semester.tableData.meta;
    },
    //loaders
    loader() {
      return Semester.getState.loading;
    },
    createLoader() {
      return Semester.postState.loading;
    },
    editLoader() {
      return Semester.editState.loading;
    },
    showLoader() {
      return Semester.showState.loading;
    },
    deleteLoader() {
      return Semester.deleteState.loading;
    },
  },
  mounted() {
    this.getData(1);
  },
};
</script>
